export function Kpi({ label, value, delta }: { label: string; value: string; delta?: string }) {
  return (
    <div className="rounded-inner border border-line bg-bg1 px-3 pb-[10px] pt-3">
      <small className="block font-mono text-[8.5px] uppercase tracking-[0.12em] text-muted mb-1">
        {label}
      </small>
      <b className="font-display text-2xl font-bold">{value}</b>
      {delta && <span className="block font-mono text-[9.5px] text-accent-bright mt-0.5">{delta}</span>}
    </div>
  );
}
